import AES from 'aes-js'

export const decrypt = (encryptedText, secret) => {
  const key = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]

  // When ready to decrypt the hex string, convert it back to bytes
  const encryptedBytes = AES.utils.hex.toBytes(encryptedText)

  // The counter mode of operation maintains internal state, so to
  // decrypt a new instance must be instantiated.
  // eslint-disable-next-line new-cap
  const aesCtr = new AES.ModeOfOperation.ctr(key, Number(secret))
  const decryptedBytes = aesCtr.decrypt(encryptedBytes)

  // Convert our bytes back into text
  return AES.utils.utf8.fromBytes(decryptedBytes)
}

export const tryParse = (rawText) => {
  // This function to fix AHA-116
  // TODO: Remove this sometime later
  try {
    return JSON.parse(rawText)
  } catch (SyntaxError) {
    return JSON.parse(decodeURIComponent(rawText))
  }
}

export const decryptAndParse = (encryptedText, secret) => {
  const rawText = decrypt(encryptedText, secret)
  return tryParse(rawText)
}
